module.exports = __webpack_public_path__ + "diamond-image04.png?d8360ad7cddc86c02d553ce2f2dcd228";